import _styled from '@emotion/styled/base';
import { css, withTheme } from '@emotion/react';
import React from 'react';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

var BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];
var DEFAULT_CONFIG = {
  grid: {
    container: {
      xs: 'full',
      sm: 'full',
      md: 45,
      lg: 60,
      xl: 71.25
    },
    padding: {
      xs: 1.875,
      sm: 1.875,
      md: 1.875,
      lg: 1.875,
      xl: 1.875
    },
    columns: {
      xs: 4,
      sm: 8,
      md: 12,
      lg: 12,
      xl: 12
    },
    gutter: {
      xs: 1.875,
      sm: 1.875,
      md: 1.875,
      lg: 1.875,
      xl: 1.875
    },
    breakpoints: {
      xs: 1,
      sm: 33.75,
      md: 48,
      lg: 64,
      xl: 71.25
    },
    colors: {
      blue: '#0470F5'
    }
  }
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function isTheme(args) {
  return args.theme === undefined;
}

var getTheme = function getTheme(args) {
  return isTheme(args) ? args : args.theme;
};

function config(props) {
  if (props === void 0) {
    props = {};
  }

  var theme = getTheme(props);
  return _extends({}, DEFAULT_CONFIG, theme);
}

function media(breakpoint) {
  var breakpoints = config().grid.breakpoints;

  if (!Object.keys(breakpoints).includes(breakpoint)) {
    throw new Error("Breakpoint '" + breakpoint + "' not found");
  }

  return "@media (min-width: " + breakpoints[breakpoint] + "em)";
}

var baseStyle$4 = function baseStyle(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("label:col;position:relative;flex:1 0 0%;width:100%;max-width:100%;box-sizing:border-box;", BREAKPOINTS.map(function (breakpoint) {
    return /*#__PURE__*/css(media(breakpoint), "{padding-left:", config(theme).grid.gutter[breakpoint] / 2, "rem;padding-right:", config(theme).grid.gutter[breakpoint] / 2, "rem;}");
  }), ";");
};

var sizeStyle = function sizeStyle(props) {
  var theme = props.theme;
  return /*#__PURE__*/css(BREAKPOINTS.map(function (breakpoint) {
    return props[breakpoint] && /*#__PURE__*/css(media(breakpoint), "{flex:0 0 ", props[breakpoint] / config(theme).grid.columns[breakpoint] * 100, "%;max-width:", props[breakpoint] / config(theme).grid.columns[breakpoint] * 100, "%;}");
  }), ";");
};

var offsetStyle = function offsetStyle(_ref2) {
  var theme = _ref2.theme,
      offset = _ref2.offset;
  return offset && typeof offset === 'object' && BREAKPOINTS.filter(function (breakpoint) {
    return offset[breakpoint];
  }).map(function (breakpoint) {
    return offset[breakpoint] && /*#__PURE__*/css(media(breakpoint), "{margin-left:", offset[breakpoint] >= 0 ? offset[breakpoint] / config(theme).grid.columns[breakpoint] * 100 : 0, "%;}");
  });
};

var Col = /*#__PURE__*/_styled('div', {
  target: "e12n51c30"
})(baseStyle$4, sizeStyle, offsetStyle);

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var baseStyle$3 = function baseStyle(_ref2) {
  var theme = _ref2.theme;
  return /*#__PURE__*/css("label:row;display:flex;flex-wrap:wrap;box-sizing:border-box;", BREAKPOINTS.map(function (breakpoint) {
    return /*#__PURE__*/css(media(breakpoint), "{margin-left:-", config(theme).grid.gutter[breakpoint] / 2, "rem;margin-right:-", config(theme).grid.gutter[breakpoint] / 2, "rem;}");
  }), ";");
};

var alignStyle = function alignStyle(_ref3) {
  var align = _ref3.align;
  return align && (typeof align === 'object' ? BREAKPOINTS.map(function (breakpoint) {
    return align[breakpoint] && /*#__PURE__*/css(media(breakpoint), "{align-items:", align[breakpoint], ";}");
  }) : /*#__PURE__*/css("align-items:", align, ";"));
};

var justifyStyle = function justifyStyle(_ref4) {
  var justify = _ref4.justify;
  return justify && (typeof justify === 'object' ? BREAKPOINTS.map(function (breakpoint) {
    return justify[breakpoint] && /*#__PURE__*/css(media(breakpoint), "{justify-content:", justify[breakpoint], ";}");
  }) : /*#__PURE__*/css("justify-content:", justify, ";"));
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "2b8jyz",
  styles: "flex-direction:row-reverse"
} : {
  name: "2b8jyz",
  styles: "flex-direction:row-reverse",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var reverseStyle = function reverseStyle(_ref5) {
  var reverse = _ref5.reverse;
  return reverse && (Array.isArray(reverse) ? BREAKPOINTS.map(function (breakpoint) {
    return /*#__PURE__*/css(media(breakpoint), "{flex-direction:", reverse.includes(breakpoint) ? 'row-reverse' : 'row', ";}");
  }) : _ref);
};

var noGutterStyle = function noGutterStyle(_ref6) {
  var noGutters = _ref6.noGutters;
  return noGutters && /*#__PURE__*/css(Col, "{padding-left:0;padding-right:0;}");
};

var Row = /*#__PURE__*/_styled('div', {
  target: "elhoft0"
})(baseStyle$3, alignStyle, justifyStyle, reverseStyle, noGutterStyle);

var baseStyle$2 = function baseStyle(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("label:container;width:100%;max-width:100%;margin-right:auto;margin-left:auto;box-sizing:border-box;", BREAKPOINTS.map(function (breakpoint) {
    return /*#__PURE__*/css(media(breakpoint), "{padding-left:", config(theme).grid.padding[breakpoint] / 2, "rem;padding-right:", config(theme).grid.padding[breakpoint] / 2, "rem;}");
  }), ";");
};

var fluidStyle = function fluidStyle(_ref2) {
  var theme = _ref2.theme,
      fluid = _ref2.fluid;
  return !fluid && BREAKPOINTS.map(function (breakpoint) {
    return /*#__PURE__*/css(media(breakpoint), "{", typeof config(theme).grid.container[breakpoint] === 'number' && "\n          max-width: " + config(theme).grid.container[breakpoint] + "rem;\n        ", ";}");
  });
};

var debugStyle = function debugStyle(_ref3) {
  var theme = _ref3.theme,
      debug = _ref3.debug;
  return debug && /*#__PURE__*/css(Row, "{background:", config(theme).grid.colors.blue, "0D;}", Col, "{background:", config(theme).grid.colors.blue, "0D;border:1px solid ", config(theme).grid.colors.blue, ";}");
};

var Container = /*#__PURE__*/_styled('div', {
  target: "e1g9m8r10"
})(baseStyle$2, fluidStyle, debugStyle);

function getBreakpoint(props) {
  if (props === void 0) {
    props = {};
  }

  var screen;

  if (typeof window !== 'undefined' && window.matchMedia) {
    Object.values(config(props).grid.breakpoints).map(function (breakpoint, index) {
      return window.matchMedia("(min-width: " + breakpoint + "em)").matches && (screen = BREAKPOINTS[index]);
    });
  }

  return screen;
}

function Hidden(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      theme = _ref.theme,
      children = _ref.children;
  var initialState = getBreakpoint();

  var _React$useState = React.useState({
    screen: initialState
  }),
      screen = _React$useState[0].screen,
      setState = _React$useState[1];

  React.useEffect(function () {
    var setScreen = function setScreen() {
      var currentScreen = getBreakpoint(theme);

      if (currentScreen !== screen) {
        setState({
          screen: currentScreen
        });
      }
    };

    setScreen(); //SSR typecheck

    if (typeof window !== 'undefined') {
      window.addEventListener('orientationchange', setScreen, false);
      window.addEventListener('resize', setScreen, false);
    }

    return function () {
      window.removeEventListener('orientationchange', setScreen);
      window.removeEventListener('resize', setScreen);
    };
  }, [theme, screen]);

  var isHidden = function isHidden() {
    switch (screen) {
      case 'xs':
        return xs;

      case 'sm':
        return sm;

      case 'md':
        return md;

      case 'lg':
        return lg;

      case 'xl':
        return xl;
    }
  };

  return !isHidden() ? jsx(React.Fragment, {
    children: children
  }) : null;
}

var Hidden$1 = withTheme(Hidden);

function Visible(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      theme = _ref.theme,
      children = _ref.children;
  var initialState = getBreakpoint();

  var _React$useState = React.useState({
    screen: initialState
  }),
      screen = _React$useState[0].screen,
      setState = _React$useState[1];

  React.useEffect(function () {
    var setScreen = function setScreen() {
      var currentScreen = getBreakpoint(theme);

      if (currentScreen !== screen) {
        setState({
          screen: currentScreen
        });
      }
    };

    setScreen(); //SSR typecheck

    if (typeof window !== 'undefined') {
      window.addEventListener('orientationchange', setScreen, false);
      window.addEventListener('resize', setScreen, false);
    }

    return function () {
      window.removeEventListener('orientationchange', setScreen);
      window.removeEventListener('resize', setScreen);
    };
  }, [theme, screen]);

  var isVisible = function isVisible() {
    switch (screen) {
      case 'xs':
        return xs;

      case 'sm':
        return sm;

      case 'md':
        return md;

      case 'lg':
        return lg;

      case 'xl':
        return xl;
    }
  };

  return isVisible() ? jsx(React.Fragment, {
    children: children
  }) : null;
}

var Visible$1 = withTheme(Visible);

function ScreenClass(_ref) {
  var theme = _ref.theme,
      render = _ref.render;

  var _React$useState = React.useState({
    screen: 'xs'
  }),
      screen = _React$useState[0].screen,
      setState = _React$useState[1];

  React.useEffect(function () {
    var setScreen = function setScreen() {
      var lastScreen = screen;
      var currentScreen = getBreakpoint(theme);

      if (lastScreen !== currentScreen) {
        lastScreen = currentScreen;
        setState({
          screen: currentScreen
        });
      }
    };

    setScreen(); //SSR typecheck

    if (typeof window !== 'undefined') {
      window.addEventListener('orientationchange', setScreen, false);
      window.addEventListener('resize', setScreen, false);
    }

    return function () {
      window.removeEventListener('orientationchange', setScreen);
      window.removeEventListener('resize', setScreen);
    };
  }, [theme, screen]);
  return typeof render === 'function' && render(screen);
}

var ScreenClass$1 = withTheme(ScreenClass);

var baseStyle$1 = function baseStyle(_ref) {
  var theme = _ref.theme,
      isActive = _ref.isActive;
  return /*#__PURE__*/css("label:button;display:flex;align-items:center;justify-content:center;position:fixed;right:30px;bottom:30px;margin:0;width:58px;height:58px;overflow:hidden;padding:0;box-sizing:border-box;color:", isActive ? "" + config(theme).grid.colors.blue : '#fff', ";font-size:14px;font-weight:bold;text-transform:uppercase;cursor:pointer;user-select:none;pointer-events:auto;-webkit-appearance:none;transition:background,color 0.2s;background:", isActive ? config(theme).grid.colors.blue + "3D" : "" + config(theme).grid.colors.blue, ";border:0;border-radius:50%;box-shadow:0 8px 32px 0 rgba(0, 0, 0, 0.12);");
};

var Button = /*#__PURE__*/_styled('div', {
  target: "efktl4g0"
})(baseStyle$1);

var baseStyle = function baseStyle(_ref) {
  var theme = _ref.theme,
      visible = _ref.visible;
  return /*#__PURE__*/css("label:grid-overlay;position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000;overflow:hidden;pointer-events:none;transform-origin:50% 0%;", Container, "{height:100%;opacity:", visible ? 1 : 0, ";transition:opacity 0.2s;}", Row, "{height:100%;background:", config(theme).grid.colors.blue, "0D;}", Col, "{height:100%;&>div{position:relative;width:100%;height:100%;&::before,&::after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:", config(theme).grid.colors.blue, "0D;}}}");
};

var GridOverlay = /*#__PURE__*/_styled('div', {
  target: "ey7hbd80"
})(baseStyle);

/**
 * NOTE:
 * https://stackoverflow.com/questions/39549424/how-to-create-unique-keys-for-react-elements/51428373
 */
var generateKey = function generateKey(pre) {
  return pre + "_" + new Date().getTime();
};

function Debugger(_ref) {
  var theme = _ref.theme;

  var _React$useState = React.useState(false),
      visible = _React$useState[0],
      setVisible = _React$useState[1];

  var _React$useState2 = React.useState({
    screen: getBreakpoint(theme),
    columns: config(theme).grid.columns[getBreakpoint(theme)]
  }),
      _React$useState2$ = _React$useState2[0],
      screen = _React$useState2$.screen,
      columns = _React$useState2$.columns,
      setState = _React$useState2[1];

  var toggleVisible = function toggleVisible() {
    return setVisible(!visible);
  };

  React.useEffect(function () {
    var setScreen = function setScreen() {
      var lastScreen = screen;
      var currentScreen = getBreakpoint(theme);

      if (lastScreen !== currentScreen) {
        lastScreen = currentScreen;
        setState({
          screen: currentScreen,
          columns: config(theme).grid.columns[currentScreen]
        });
      }
    };

    setScreen(); //SSR typecheck

    if (typeof window !== 'undefined') {
      window.addEventListener('orientationchange', setScreen, false);
      window.addEventListener('resize', setScreen, false);
    }

    return function () {
      window.removeEventListener('orientationchange', setScreen);
      window.removeEventListener('resize', setScreen);
    };
  }, [theme, screen]);
  return jsxs(React.Fragment, {
    children: [jsx(GridOverlay, {
      visible: visible,
      children: jsx(Container, {
        children: jsx(Row, {
          children: Array(columns).fill('').map(function (item, index) {
            return jsx(Col, {
              children: jsx("div", {})
            }, generateKey(index));
          })
        })
      })
    }), jsx(Button, {
      onClick: toggleVisible,
      isActive: visible,
      children: screen
    })]
  });
}

var Debugger$1 = withTheme(Debugger);

export { Col, Container, Debugger$1 as Debugger, Hidden$1 as Hidden, Row, ScreenClass$1 as ScreenClass, Visible$1 as Visible, config, media };
